module.exports = __webpack_public_path__ + "static/img/v_ba_p_2_2.7eb63175.png";